import React, { useState } from "react";
import {
  FlexRowBetween,
  GenericDiv,
  Input,
  Label,
  PopupForm,
} from "../common/Style";
import { createLink } from "../../store/reducers/paymentsReducer";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import CopyText from "../common/others/CopyText";
import OpacityLoading from "../common/loader/OpacityLoading";
import { editUserById } from "../../store/reducers/userReducer";

const Stats = ({ user }) => {
  const { isItay } = useSelector((state) => state.authReducer.user);
  const dispatch = useDispatch();
  let sum = 0;
  let itay = 0;
  let seatup = 0;
  let sms = parseFloat(0.01 * user.smsCounter * 1.17).toFixed(2);
  let wha = parseFloat(0.17 * user.whaCounter * 1.17).toFixed(2);
  // let calls = parseFloat(user.talsCounter);
  let calls = parseFloat(user.restRecordsAtFirstCall) * parseFloat(1.2);
  let records = (parseFloat(user.deal) * parseFloat(user.records)).toFixed(2);
  let paybox =
    user.paybox !== "" && user.paybox !== null ? parseFloat(user.giftCost) : 0;
  let payboxTax = parseFloat(user.payboxTax);
  let digitalSeatCost = user.isDigitalSeat
    ? parseFloat(user.digitalSeatCost)
    : 0;
  sum =
    parseFloat(records) +
    parseFloat(paybox) +
    parseFloat(payboxTax) +
    parseFloat(digitalSeatCost);
  let expenses = parseFloat(sms) + parseFloat(wha) + parseFloat(calls);
  seatup = parseFloat((parseFloat(sum) - parseFloat(expenses)) / 2);
  itay = parseFloat(sum) - parseFloat(payboxTax) - parseFloat(seatup);
  const [price, setPrice] = useState(parseFloat(itay) + parseFloat(seatup));
  const [link, setLink] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleCreateLink = async () => {
    if (user.isPaid) {
      setLoading(true);
      dispatch(editUserById(user._id, { itay })).then((res) => {
        setLoading(false);
        if (res.payload?.error) toast.error(res.payload?.error);
        else toast.success(`נרשם לאיתי ${itay}₪ בהצלחה!`);
      });
      // let body = {
      //   total: parseFloat(price),
      //   name: user._id,
      //   uid: user._id,
      //   records: user.records,
      //   deal: user.deal,
      //   digitalSeat: digitalSeatCost,
      //   gift: paybox,
      // };
      // dispatch(createLink(body)).then((res) => {
      //   setLoading(false);
      //   if (res.payload.error) toast.error(res.payload.error);
      //   else setLink(`${res.payload}`);
      // });
    } else toast.warning("לא ניתן להפריש אם הכסף עוד לא שולם");
  };

  const handleClick = (e) => {
    if (e.type === "contextmenu") toast.info(itay);
  };

  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      className="animate__animated animate__fadeIn"
      style={{ padding: "20px" }}
    >
      <table style={{ textAlign: "center", width: "90%", margin: "0 auto" }}>
        <tr>
          <th></th>
          <th>כמות</th>
          <th>מחיר (₪)</th>
          <th style={{ width: "max-content" }}>סה״כ (₪)</th>
        </tr>

        <tr>
          <th>sms</th>
          <td>{user.smsCounter}</td>
          <td>0.01</td>
          <td style={{ background: "#ec707035" }}>{sms}</td>
        </tr>

        <tr>
          <th>ווצאפ</th>
          <td>{user.whaCounter}</td>
          <td>0.17</td>
          <td style={{ background: "#ec707035" }}>{wha}</td>
        </tr>

        {isItay && (
          <tr>
            <th>שיחות</th>
            <td></td>
            <td></td>
            <td style={{ background: "#ec707035" }}>
              {parseFloat(user.talsCounter).toFixed(2)}
            </td>
          </tr>
        )}

        <tr>
          <th>שיחות</th>
          <td>{user.restRecordsAtFirstCall}</td>
          <td>1.2</td>
          <td style={{ background: "#ec707035" }}>
            {parseFloat(user.restRecordsAtFirstCall) * parseFloat(1.2)}
          </td>
        </tr>

        <tr>
          <th>רשומות</th>
          <td>{user.records}</td>
          <td>{user.deal}</td>
          <td style={{ background: "#e1e9f7" }}>{records}</td>
        </tr>

        <tr>
          <th>מתנות באשראי</th>
          <td>{user.paybox !== "" && user.paybox !== null ? 1 : 0}</td>
          <td>{user.giftCost}</td>
          <td style={{ background: "#e1e9f7" }}>{paybox}</td>
        </tr>

        <tr>
          <th>עמלות אשראי</th>
          <td></td>
          <td></td>
          <td style={{ background: "#e1e9f7" }}>{payboxTax}</td>
        </tr>

        <tr>
          <th>הושבה דיגיטלית</th>
          <td>{user.isDigitalSeat ? 1 : 0}</td>
          <td>{user.digitalSeatCost}</td>
          <td style={{ background: "#e1e9f7" }}>{digitalSeatCost}</td>
        </tr>
      </table>

      <FlexRowBetween style={{ marginTop: "30px", alignItems: "flex-end" }}>
        {/* <div style={{ width: "40%" }}>
          <Label onContextMenu={handleClick}>סכום לתשלום (₪)</Label>
          <Input
          <GenericDiv onClick={handleCreateLink}>חישוב</GenericDiv>
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
        </div> */}
        {/* <GenericDiv onClick={handleCreateLink}>יצירת לינק</GenericDiv> */}
        {/* {link ? (
          <CopyText marginLeft={"5px"} dataToCopy={link} text={"העתקת הלינק"} />
        ) : (
          <GenericDiv onClick={handleCreateLink}>יצירת לינק לתשלום</GenericDiv>
        )} */}
        {/* {user.itay === 0 && isItay && ( */}
        <GenericDiv onClick={handleCreateLink}>חישוב</GenericDiv>
        {/* )} */}
        {/* {user.itay === 0 && isItay && <GenericDiv>{user.itay}</GenericDiv>} */}
      </FlexRowBetween>

      {loading && <OpacityLoading />}
    </PopupForm>
  );
};

export default Stats;
